import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import CustomTab from '../components/CustomTab';
import SubPageHeader from '../components/SubPageHeader';
import partExampleImg from '../assets/images/140.png';

export default function PreWorkDetailsPage({ data, pageContext }) {
  const details = data.prework;
  const breadcrumbs = [
    {
      title: 'Pre-Work',
      url: '/pre-work',
    },
    {
      title: pageContext.familyName,
      url: `/pre-work/${pageContext.familyUrl}`,
    },
  ];
  const parts = [];
  details.parts.map((item) =>
    parts.push({
      quantity: item.quantity,
      comment: item.comment,
      article_number: item.parts.article_number,
      name: item.parts.name,
      image:
        item.parts.image != null
          ? item.parts.image.asset.fluid.src
          : partExampleImg,
    })
  );

  return (
    <Layout>
      <SubPageHeader title={pageContext.name} breadcrumbs={breadcrumbs} />
      <CustomTab
        parts={parts}
        gallery={details.gallery}
        video={details.video}
      />
    </Layout>
  );
}

export const query = graphql`
  query PreWorkQuery($url: String) {
    prework: sanityPreWork(url: { current: { eq: $url } }) {
      video
      id
      family {
        name
        url {
          current
        }
        id
      }
      gallery {
        description
        alt
        image {
          asset {
            fluid {
              src
            }
          }
        }
      }
      parts {
        quantity
        comment
        parts {
          name
          article_number
          id
          image {
            asset {
              fluid(maxWidth: 300) {
                ...GatsbySanityImageFluid
              }
            }
          }
        }
      }
    }
  }
`;
